<ion-grid class="center">
	<ion-row>
		<ion-col>
			<ion-grid class="max-w-1336" *ngIf="emailTemplateList$ | async as emailTemplateList">
				<ng-container *ngIf="emailTemplateList.isSkeleton">
					<ion-grid class="side-menu-wrapper text-center">
						<ion-spinner class="ion-spinner"></ion-spinner>
					</ion-grid>
				</ng-container>
				<ng-container *ngIf="!emailTemplateList.isSkeleton">
					<ion-row>
						<ion-col col="12">
							<dx-data-grid id="gridContainer" [dataSource]="emailTemplateList.data"
								[allowColumnResizing]="true" [columnAutoWidth]="true" [showBorders]="true">
								<dxo-search-panel [visible]="true" [width]="240"
									placeholder="Search..."></dxo-search-panel>
								<dxo-header-filter [visible]="true"></dxo-header-filter>
								<dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
								<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

								<dxi-column caption="Actions" dataField="id" [allowFiltering]="false"
									[allowSorting]="false" cellTemplate="cellTemplate" [width]="150" [fixed]="true">
								</dxi-column>

								<div *dxTemplate="let d of 'cellTemplate'">
									<a (click)="editEmailTemplate(d.data.ID)" class="cursor">View</a>
									<!-- <a (click)="editEmailTemplate(d.data.id)" class="cursor"
										>Edit</a
									>
									/
									<a
										appConfirmBox
										(learnDelete)="deleteEmailTemplate(d.data.id)"
										title="Delete FAQ"
										subTitle="Are you sure you want to delete your FAQ ?"
										class="Body_S text-right"
										>Delete</a
									> -->
								</div>

								<dxi-column dataField="ID" caption="ID"></dxi-column>
								<dxi-column dataField="email_template" caption="Email-template"></dxi-column>
								<dxi-column dataField="subject" caption="Subject"></dxi-column>

								<dxo-toolbar>
									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<ion-button (click)="createEmailTemplate()"><ion-icon
													name="add-outline"></ion-icon></ion-button>
										</div>
									</dxi-item>

									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<p class="Heading_M">Add New Email-Template</p>
										</div>
									</dxi-item>

									<dxi-item name="columnChooserButton"></dxi-item>

									<dxi-item name="searchPanel"></dxi-item>
								</dxo-toolbar>
							</dx-data-grid>
						</ion-col>
					</ion-row>
				</ng-container>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>